import { type SerializedCompStructure } from '@wix/document-services-types'

import { assertNonNullable } from './assertNonNullable'
import { assertConnectionList } from './assertConnectionList'

export const setComponentVeloId = ({
  component,
  veloId,
}: {
  component: SerializedCompStructure
  veloId: string
}): SerializedCompStructure => {
  const connectionList = component.connections
  assertNonNullable(connectionList)
  assertConnectionList(connectionList)
  const { items } = component.connections
  for (let index = 0; index < items.length; index += 1) {
    const connection = items[index]
    if (connection.type === 'WixCodeConnectionItem') {
      return {
        ...component,
        connections: {
          ...component.connections,
          items: [
            ...items.slice(0, index),
            { ...connection, role: veloId },
            ...items.slice(index + 1),
          ],
        },
      }
    }
  }
  throw new Error(`No wix-code connection found.`)
}
